export const environment = {
  production: false,
  defaultUrlServer: 'https://app.pingsm.ro/api/',
  deployId: '9617e359-d44e-4a48-8457-de9ae3392785',
  filePath: 'https://app.pingsm.ro/api/mds_file/',
  authServer: 'https://app.pingsm.ro/api/auth/',
  saasServer: 'https://app.pingsm.ro/api/saas/',
  signalR: 'https://app.pingsm.ro/api/saas_hub',
};